import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const CONSENT_KEY = "orbit_cookie_consent";

let gaLoaded = false;
export function loadGA() {
  if (!GA_ID || gaLoaded || typeof window === "undefined") return;
  gaLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false, anonymize_ip: true });
}

export default function Analytics() {
  const location = useLocation();

  useEffect(() => {
    try { if (localStorage.getItem(CONSENT_KEY) === "all") loadGA(); } catch { /* ignore */ }
  }, []);

  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith("/app/") || path.startsWith("/scan/")) return;
    api.post("/track/pageview", { path, referrer: document.referrer || "" }).catch(() => {});
    if (window.gtag && gaLoaded) window.gtag("event", "page_view", { page_path: path, page_location: window.location.href });
  }, [location.pathname]);

  return null;
}
